import { useParams, useRouteMatch } from 'react-router-dom'

import {
  Model,
  LoadingContainer,
  Modal,
  Panels,
  Bar,
  Input,
  Breadcrumb,
} from 'peach/components'
import { getName } from 'peach/helpers'
import {
  CompanyTeamSelect,
  CompanyEmployeeSelect,
  CompanyAgentUserSelect,
} from 'peach/scopes/company'

import {
  useInternalEmployeeGetById,
  useInternalEmployeeUpdate,
  useInternalEmployeeAddToTeam,
} from 'core/types'
import { Page } from 'core/components'

const CompanyEmployee = () => {
  const { url } = useRouteMatch()
  const { companyId, employeeId } = useParams()

  const {
    data: employee,
    isLoading,
    error,
    refetch,
  } = useInternalEmployeeGetById({ companyId, employeeId })

  const { mutateAsync: updateEmployee } = useInternalEmployeeUpdate({
    companyId,
    employeeId,
  })

  const { mutateAsync: addToTeam } = useInternalEmployeeAddToTeam({
    companyId,
    employeeId,
    teamId: undefined,
  })

  const editEmployee = (
    <Modal
      initialValue={{ userId: employee?.user?.id, ...employee }}
      onSubmit={async (values) => {
        await updateEmployee(values)
        refetch()
      }}
      title='Edit Employee'
      trigger
    >
      <Input formKey='firstName' />
      <Input formKey='lastName' />
      <Input formKey='jobName' />
      <CompanyAgentUserSelect
        formKey='userId'
        label='User'
        nullable
        searchable
      />
      <CompanyEmployeeSelect
        formKey='managerEmployeeId'
        label='Manager Employee'
        nullable
        searchable
      />
    </Modal>
  )

  const addToTeamModal = (
    <Modal
      onSubmit={async (values) => {
        await addToTeam(undefined, {
          companyId,
          employeeId,
          teamId: values.teamId,
        })
        await refetch()
      }}
      title='Add To Team'
      trigger
    >
      <CompanyTeamSelect companyId={companyId} formKey='teamId' />
    </Modal>
  )

  const name = getName(employee)

  const header = (
    <Bar
      right={
        <>
          {addToTeamModal}
          {editEmployee}
        </>
      }
      title={name}
    />
  )

  return (
    <Panels header={header}>
      <Breadcrumb title={name} to={url} />
      <LoadingContainer error={error} loading={isLoading}>
        <Page>
          <Model.Item json={employee} />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default CompanyEmployee
